<template>
  <v-dialog v-model="dialogVisible" scrollable persistent max-width="900" @keydown.esc="cancelForm()">
    <v-card class="permissions-form-card">
      <v-card-title class="primary white--text py-4">
        <v-icon left color="white">mdi-shield-key</v-icon>
        Asignar Permisos
        <v-spacer></v-spacer>
        <v-btn small text color="white" @click="expandAll" class="mr-2">
          <v-icon small left>mdi-chevron-down</v-icon>
          Expandir todo
        </v-btn>
        <v-btn small text color="white" @click="collapseAll" class="mr-2">
          <v-icon small left>mdi-chevron-up</v-icon>
          Colapsar todo
        </v-btn>
        <v-btn icon dark @click="cancelForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-alert type="info" outlined dense class="mb-4">
                <v-icon left>mdi-information-outline</v-icon>
                Selecciona los permisos específicos que tendrá este usuario. Los permisos complementan los roles asignados.
              </v-alert>
            </v-col>
          </v-row>

          <!-- Permisos agrupados por categoría -->
          <v-expansion-panels v-model="expandedPanels" multiple class="mb-4 elevation-0">
            <v-expansion-panel
              v-for="category in permissionCategories"
              :key="category.key"
              class="mb-2"
            >
              <v-expansion-panel-header class="px-4 py-3">
                <div class="d-flex align-center">
                  <v-icon :color="category.color" left>{{ category.icon }}</v-icon>
                  <div>
                    <div class="font-weight-medium text-body-1">{{ category.title }}</div>
                    <div class="text-caption text--secondary">{{ category.description }}</div>
                  </div>
                </div>
                <template v-slot:actions>
                  <div class="d-flex align-center">
                    <v-chip
                      x-small
                      :color="category.color"
                      text-color="white"
                      class="mr-3"
                    >
                      {{ category.permissions.length }}
                    </v-chip>
                    <v-icon :color="category.color">$expand</v-icon>
                  </div>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pa-0">
                <v-divider></v-divider>
                <v-card flat class="pa-4">
                  <div class="permission-grid">
                    <v-checkbox
                      v-for="permission in category.permissions"
                      :key="permission.value"
                      v-model="selectedPermissions"
                      :value="permission.value"
                      :label="permission.label"
                      dense
                      hide-details
                      class="permission-checkbox"
                    ></v-checkbox>
                  </div>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          @click="cancelForm()"
          color="grey darken-1"
          text
          class="px-4"
        >
          <v-icon left>mdi-close</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          @click="savePermissions()"
          color="primary"
          class="px-4"
          depressed
        >
          <v-icon left>mdi-content-save</v-icon>
          Guardar Permisos
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PermissionsForm',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    selectedPermissions: [],
    expandedPanels: [], // Controla qué paneles están expandidos

    // Permisos agrupados por categoría
    userPermissions: [
      { value: 'actualizar_usuario', label: 'Actualizar usuario' },
      { value: 'agregar_usuario_normal', label: 'Agregar usuario normal' },
      { value: 'eliminar_usuario', label: 'Eliminar usuario' }
    ],

    vehiclePermissions: [
      { value: 'crear_vehiculo', label: 'Crear vehículo' },
      { value: 'editar_vehiculo', label: 'Editar vehículo' },
      { value: 'eliminar_vehiculo', label: 'Eliminar vehículo' },
      { value: 'asignar_todo', label: 'Asignar TO-DO' },
      { value: 'asignar_estado_proceso', label: 'Asignar Estado Proceso' },
      { value: 'exportar_vehiculos', label: 'Exportar Vehículos' }

    ],

    movementPermissions: [
      { value: 'crear_movimiento', label: 'Crear movimiento' },
      { value: 'editar_movimiento', label: 'Editar movimiento' },
      { value: 'eliminar_movimiento', label: 'Eliminar movimiento' },
      { value: 'aceptar_movimiento', label: 'Aceptar movimiento' },
      { value: 'view_chekbox_validacion', label: 'Ver checkbox de validación' },
      { value: 'usage_chekbox_validacion', label: 'Usar checkbox de validación' }
    ],

    cesionPermissions: [
      { value: 'crear_cesion', label: 'Crear cesión' },
      { value: 'editar_cesion', label: 'Editar cesión' },
      { value: 'eliminar_cesion', label: 'Eliminar cesión' },
      { value: 'aceptar_cesion', label: 'Aceptar cesión' }
    ],

    locationPermissions: [
      { value: 'crear_ubicacion', label: 'Crear ubicación' },
      { value: 'editar_ubicacion', label: 'Editar ubicación' },
      { value: 'eliminar_ubicacion', label: 'Eliminar ubicación' }
    ],

    driverPermissions: [
      { value: 'crear_conductor', label: 'Crear conductor' },
      { value: 'editar_conductor', label: 'Editar conductor' }
      // { value: 'eliminar_conductor', label: 'Eliminar conductor' }
    ],

    cranePermissions: [
      { value: 'crear_grua', label: 'Crear grúa' },
      { value: 'editar_grua', label: 'Editar grúa' }
      // { value: 'eliminar_grua', label: 'Eliminar grúa' }
    ],

    systemPermissions: [
      { value: 'manage_dealer', label: 'Administrar dealer' },
      { value: 'manage_equipamiento_config', label: 'Configurar equipamiento' },
      { value: 'manage_notifications', label: 'Administrar notificaciones' },
      { value: 'crear_todo', label: 'Crear TO-DO' },
      { value: 'editar_todo', label: 'Editar TO-DO' },
      { value: 'eliminar_todo', label: 'Eliminar TO-DO' },
      { value: 'crear_estado_proceso', label: 'Crear Estado Proceso' },
      { value: 'editar_estado_proceso', label: 'Editar Estado Proceso' },
      { value: 'eliminar_estado_proceso', label: 'Eliminar Estado Proceso' }
      // { value: 'manage_users', label: 'Administrar usuarios' }
    ],

    importPermissions: [
      { value: 'importacion_masiva_excel', label: 'Importación masiva Excel' }
    ],

    otherPermissions: [
      { value: 'descargar_comodato', label: 'Descargar comodato' }
    ]
  }),

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    },

    permissionCategories() {
      return [
        {
          key: 'users',
          title: 'Gestión de Usuarios',
          description: 'Permisos para administrar cuentas de usuario',
          icon: 'mdi-account-group',
          color: 'blue',
          permissions: this.userPermissions
        },
        {
          key: 'vehicles',
          title: 'Gestión de Vehículos',
          description: 'Permisos para crear, editar y eliminar vehículos',
          icon: 'mdi-car-multiple',
          color: 'green',
          permissions: this.vehiclePermissions
        },
        {
          key: 'movements',
          title: 'Gestión de Movimientos',
          description: 'Permisos para gestionar movimientos y transportes',
          icon: 'mdi-truck-delivery',
          color: 'orange',
          permissions: this.movementPermissions
        },
        {
          key: 'cesion',
          title: 'Gestión de Cesiones',
          description: 'Permisos para gestionar cesiones',
          icon: 'mdi-swap-horizontal',
          color: 'orange',
          permissions: this.cesionPermissions
        },
        {
          key: 'locations',
          title: 'Gestión de Ubicaciones',
          description: 'Permisos para administrar ubicaciones y sedes',
          icon: 'mdi-map-marker-multiple',
          color: 'purple',
          permissions: this.locationPermissions
        },
        {
          key: 'drivers',
          title: 'Gestión de Conductores',
          description: 'Permisos para administrar conductores',
          icon: 'mdi-account-tie',
          color: 'teal',
          permissions: this.driverPermissions
        },
        {
          key: 'cranes',
          title: 'Gestión de Grúas',
          description: 'Permisos para administrar empresas de grúas',
          icon: 'mdi-crane',
          color: 'brown',
          permissions: this.cranePermissions
        },
        {
          key: 'system',
          title: 'Sistema y Configuración',
          description: 'Permisos administrativos del sistema',
          icon: 'mdi-cog-outline',
          color: 'grey darken-1',
          permissions: this.systemPermissions
        },
        {
          key: 'import',
          title: 'Importación de Datos',
          description: 'Permisos para importar datos masivamente',
          icon: 'mdi-file-excel-box',
          color: 'success',
          permissions: this.importPermissions
        },
        {
          key: 'other',
          title: 'Permisos Especiales',
          description: 'Permisos adicionales y específicos',
          icon: 'mdi-star-circle',
          color: 'amber darken-2',
          permissions: this.otherPermissions
        }
      ]
    }
  },

  watch: {
    value: {
      handler(newVal) {
        this.selectedPermissions = [...newVal]
      },
      immediate: true
    },
    visible(newVal) {
      if (newVal) {
        this.selectedPermissions = [...this.value]
      }
    }
  },

  methods: {
    savePermissions() {
      this.$emit('input', [...this.selectedPermissions])
      this.$emit('update:visible', false)
      this.$toast.success('Permisos actualizados correctamente')
    },

    cancelForm() {
      this.selectedPermissions = [...this.value]
      this.$emit('update:visible', false)
    },

    expandAll() {
      // Expande todos los paneles (0-8, total 9 paneles)
      this.expandedPanels = [0, 1, 2, 3, 4, 5, 6, 7, 8]
    },

    collapseAll() {
      // Colapsa todos los paneles
      this.expandedPanels = []
    }
  }
}
</script>

<style scoped>
.permissions-form-card {
  border-radius: 8px;
  overflow: hidden;
}

.v-expansion-panels {
  border-radius: 8px;
}

.v-expansion-panel {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px !important;
  margin-bottom: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.v-expansion-panel:hover {
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.v-expansion-panel::before {
  box-shadow: none;
}

.v-expansion-panel-header {
  padding: 16px 20px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.9) 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.v-expansion-panel-header--active {
  border-bottom-color: rgba(25, 118, 210, 0.2);
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.02) 0%, rgba(25, 118, 210, 0.05) 100%);
}

.v-expansion-panel-content__wrap {
  padding: 0;
}

.permission-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 8px;
  padding: 16px;
}

.permission-checkbox {
  margin-bottom: 8px;
}

.permission-checkbox .v-input--selection-controls__input {
  margin-right: 8px;
}

.permission-checkbox .v-label {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

/* Responsive */
@media (max-width: 600px) {
  .permission-grid {
    grid-template-columns: 1fr;
  }

  .v-expansion-panel-header {
    padding: 12px 16px;
  }
}
</style>
